import { Box, Flex, HStack, Text } from "@chakra-ui/react";
import YoYChip from "../components/YoYChip";

// Light KPI card matching the carbon detail-page KpiCard (ScopeOneDetail etc):
// a coloured accent top-rule, title + subtitle, a fluid big number with the
// YoYChip and unit stacked to its right, and an optional footer figure/label.
// Shared by the supplier drill-down pages so they read like the carbon ones.
//
// Props:
//  - accent: top-rule colour
//  - title / subtitle
//  - value: pre-formatted display string (caller formats)
//  - unit: shown small beside the number (default tCO₂e)
//  - pctChange: numeric YoY for the chip (null = no chip). Down = green.
//  - footerValue / footerLabel: optional secondary line beneath the number
//  - loading
const SupplierKpiCard = ({
  accent = "darkTeal",
  title,
  subtitle,
  value,
  valueColor = "darkTeal",
  unit = "tCO₂e",
  pctChange = null,
  footerValue,
  footerLabel,
  loading = false,
  children,
}) => (
  <Box position="relative" pt={3}>
    <Box position="absolute" top={0} left={0} right={0} h="3px" bg={accent} borderRadius="full" />
    <HStack align="baseline" spacing={2} mb={2}>
      <Text fontSize="15px" fontWeight="700" color="darkTeal">
        {title}
      </Text>
      {subtitle && (
        <Text fontSize="13px" color="gray.500">
          {subtitle}
        </Text>
      )}
    </HStack>
    <Box position="relative" display="inline-block" whiteSpace="nowrap" sx={{ "--big": "clamp(20px, 3vw, 56px)" }}>
      <Flex align="flex-end" gap={3}>
        <Text fontSize="var(--big)" fontWeight="700" color={valueColor} lineHeight="1" letterSpacing="-0.02em">
          {loading ? "…" : value ?? "—"}
        </Text>
        <Flex direction="column" justify="space-between" alignSelf="stretch" flexShrink={0}>
          {pctChange != null ? <YoYChip pctChange={pctChange} /> : <Box />}
          {unit && (
            <Text fontSize="calc(var(--big) * 0.36)" fontWeight="600" color="gray.600" lineHeight="1">
              {unit}
            </Text>
          )}
        </Flex>
      </Flex>
    </Box>
    {(footerValue != null || footerLabel) && (
      <HStack spacing={2} mt={3} align="baseline" flexWrap="wrap">
        {footerValue != null && (
          <Text fontSize={{ base: "16px", lg: "20px", xl: "22px" }} fontWeight="700" color="darkTeal" lineHeight="1">
            {footerValue}
          </Text>
        )}
        {footerLabel && (
          <Text fontSize="13px" color="gray.500">
            {footerLabel}
          </Text>
        )}
      </HStack>
    )}
    {children && <Box mt={4}>{children}</Box>}
  </Box>
);

export default SupplierKpiCard;
